import React, { useState } from "react";

//UI Material
import { IconButton, Stack, TableCell, TableRow } from "@mui/material";

//Material Icons
import { Delete, NoteAdd } from "@mui/icons-material";

//Helpers
import { typographyForText } from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

//Local components
import ModalWindow from "../Modal";
import ActionOfColaboratorDrawer from "../drawers/ActionOfColaboratorDrawer";

export default function UserRow({ user, getUsers }) {
  // ==========>Component States<==========
  //State for open confirmation modal
  const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
  //State for open modal
  const [modalOpen, setModalOpen] = useState(false);
  //State for modal text
  const [modalText, setModalText] = useState("");
  //State for modal description
  const [modalDescription, setModalDescription] = useState("");
  //State for drawer open/close
  const [
    openDrawerForActionOfColaborator,
    setOpenDrawerForActionOfColaborator,
  ] = useState(false);

  // ==========>Component Functions<==========
  //Function to delete an existing user
  const deleteUser = async (email) => {
    setConfirmationModalOpen(false);
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/users/delete-user`,
        {
          userEmail: email,
        }
      );
      const jsonResponse = await requestResponse.json();
      if (jsonResponse.status === 200) {
        getUsers();
        setModalText("Usuario eliminado.");
      } else {
        setModalText("No se pudo eliminar al usuario");
      }
      setModalOpen(true);
      setModalDescription(jsonResponse.description);
    } catch (error) {
      setModalText("No se pudo realizar la acción.");
      setModalDescription(
        "Por favor compruebe su conexión e intente nuevamente más tarde."
      );
    }
  };

  //Function to select the type of row according to screen size
  const selectRowType = (user) => {
    return (
      <TableRow>
        <ActionOfColaboratorDrawer
          data={user}
          open={openDrawerForActionOfColaborator}
          setOpen={setOpenDrawerForActionOfColaborator}
        />
        <TableCell align="center">{typographyForText(user.user)}</TableCell>
        <TableCell align="center">
          {typographyForText(new Date(user.createdAt).toLocaleDateString())}
        </TableCell>
        <TableCell align="center">{typographyForText(user.email)}</TableCell>
        <TableCell align="center">{typographyForText(user.position)}</TableCell>
        <TableCell align="center">
          {typographyForText(new Date(user.createdAt).toLocaleDateString())}
        </TableCell>
        <TableCell align="center">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="center"
            spacing={1}
          >
            {typographyForText(0)}
            <IconButton
              size="small"
              onClick={() => {
                setOpenDrawerForActionOfColaborator(true);
              }}
            >
              <NoteAdd color="secondary" />
            </IconButton>
          </Stack>
        </TableCell>
        <TableCell align="center">{typographyForText(user.role)}</TableCell>
        <TableCell align="center">
          <IconButton
            disabled={user.role === "ADMINISTRATOR"}
            onClick={() => {
              setConfirmationModalOpen(true);
            }}
          >
            <Delete
              sx={{ color: user.role === "COLABORATOR" ? "red" : null }}
            />
          </IconButton>
        </TableCell>
        <ModalWindow
          isOpen={confirmationModalOpen}
          handleClose={() => setConfirmationModalOpen(false)}
          title={`Eliminar usuario`}
          text={`¿Desea eliminar permanentemente al usuario ${user.user} del sistema?`}
          leftText="Cancelar"
          leftClick={() => {
            setConfirmationModalOpen(false);
          }}
          leftColor="error"
          rightText="Sí, eliminar"
          rightClick={() => {
            deleteUser(user.email);
          }}
        />
        <ModalWindow
          isOpen={modalOpen}
          handleClose={() => setModalOpen(false)}
          title={modalText}
          text={modalDescription}
          leftText="OK"
          leftClick={() => {
            setModalOpen(false);
          }}
        />
      </TableRow>
    );
  };

  return selectRowType(user);
}
